import { useSuspensionContext } from "../../context/suspension";

// Degraded-path copy only — used when the backend supplied nothing at all. The
// title and message are backend-owned and environment-overridable, so a
// supplied value always wins.
const FALLBACK_TITLE = "Organization Suspended";
const FALLBACK_MESSAGE = "This organization is currently unavailable.";

const OrganizationSuspended = () => {
    const { notice } = useSuspensionContext();

    return (
        <div className="flex min-h-screen items-center justify-center bg-base-200 p-6">
            <div className="max-w-md rounded-lg border border-line bg-base-100 p-8 text-center shadow-2xl">
                <h1 className="text-2xl font-semibold text-error">
                    {notice.title ?? FALLBACK_TITLE}
                </h1>
                <p className="mt-4 text-base-content">
                    {notice.message ?? FALLBACK_MESSAGE}
                </p>
            </div>
        </div>
    );
};

export default OrganizationSuspended;
